// Reveals [data-geo-gate] elements unless the visitor's IP resolves to Northern Ireland.
// See snippets/geo-gate.liquid for why this can't be done in Liquid.
(() => {
  if (window.geoGateInitialised) return;
  window.geoGateInitialised = true;

  const STORAGE_KEY = 'geoGateRegion';
  const LOOKUP_TIMEOUT = 4000;
  const RESTRICTED_REGION_NAME = 'Northern Ireland';
  const RESTRICTED_REGION_CODE = 'NIR';
  // const RESTRICTED_REGION_NAME = 'Somerset'; // Testing
  // const RESTRICTED_REGION_CODE = 'SOM'; // Testing
  // TODO: set to false before go-live - logs lookup results to the console for testing
  const DEBUG = true;

  const log = (...args) => {
    if (DEBUG) console.log('GeoGate:', ...args);
  };

  const config = document.querySelector('script[data-geo-gate-config]');
  const accessKey = config ? config.dataset.accessKey : '';
  const showOnFailure = config ? config.dataset.showOnFailure === 'true' : true;

  const getCachedRegion = () => {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY));
    } catch (e) {
      return null;
    }
  };

  const setCachedRegion = (region) => {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(region));
    } catch (e) {
      // Storage unavailable (e.g. private browsing) - lookup will run again on the next page
    }
  };

  const lookupRegion = async () => {
    if (!accessKey) throw new Error('No IPStack access key set in theme settings');

    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), LOOKUP_TIMEOUT);

    try {
      const response = await fetch(
          `https://api.ipstack.com/check?access_key=${encodeURIComponent(accessKey)}&fields=country_code,region_code,region_name`,
          { signal: controller.signal }
      );
      const data = await response.json();

      // IPStack returns 200 with { success: false, error } for key/quota problems
      if (data.success === false || !data.country_code) {
        throw new Error(data.error ? data.error.info : 'Invalid IPStack response');
      }

      log('IPStack response', data);

      return {
        countryCode: data.country_code,
        regionCode: data.region_code,
        regionName: data.region_name,
      };
    } finally {
      clearTimeout(timeout);
    }
  };

  const isRestricted = (region) => {
    return region.countryCode === 'GB' && (
        region.regionName === RESTRICTED_REGION_NAME ||
        region.regionCode === RESTRICTED_REGION_CODE
    );
  };

  const reveal = () => {
    document.querySelectorAll('[data-geo-gate][hidden]').forEach((element) => {
      element.hidden = false;
    });
  };

  const init = async () => {
    let region = getCachedRegion();

    if (region) {
      log(`using cached region from sessionStorage ("${STORAGE_KEY}")`);
    } else {
      log('no cached region, looking up with IPStack');
      try {
        region = await lookupRegion();
        setCachedRegion(region);
      } catch (e) {
        console.warn('GeoGate: region lookup failed', e);
        log(showOnFailure ? 'showing personalisation (show on failure is on)' : 'keeping personalisation hidden (show on failure is off)');
        if (showOnFailure) reveal();
        return;
      }
    }

    const restricted = isRestricted(region);
    log('location', {
      country: region.countryCode,
      regionName: region.regionName,
      regionCode: region.regionCode,
      restricted,
    });
    log(restricted ? 'Northern Ireland - keeping personalisation hidden' : 'not Northern Ireland - showing personalisation');

    if (!restricted) reveal();
  };

  init();
})();
